import React from 'react';
import { motion } from 'framer-motion';
import { getSoldOrReservedUnits, formatArea } from '../data/units';
import { CheckCircleIcon, HomeIcon } from 'lucide-react';
export function UnitsSection() {
  const soldUnits = getSoldOrReservedUnits().slice(0, 6);
  return <section id="byty" className="py-24 bg-base-cream" data-id="element-229">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-231">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-232">
            Nabídka bytů
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-233">
            Prohlédněte si naši nabídku bytových jednotek. Kontaktujte nás pro
            více informací a aktuální ceník.
          </p>
        </motion.div>

        {/* Sold/Reserved Units - "Rozjednané jednotky" */}
        {soldUnits.length > 0 && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-16" data-id="element-234">
            <div className="flex items-center gap-3 mb-8" data-id="element-235">
              <CheckCircleIcon className="w-6 h-6 text-accent" data-id="element-236" />
              <h3 className="font-heading text-2xl text-primary" data-id="element-237">
                Rozjednané jednotky
              </h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-238">
              {soldUnits.map((unit, index) => <motion.div key={unit.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm relative overflow-hidden" data-id="element-239">
                  {/* Status badge */}
                  <div className="absolute top-4 right-4" data-id="element-240">
                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${unit.stav === 'prodáno' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-241">
                      {unit.stav === 'prodáno' ? 'Prodáno' : 'Rezervováno'}
                    </span>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-242">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0" data-id="element-243">
                      <HomeIcon className="w-6 h-6 text-primary" data-id="element-244" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-245">
                      <h4 className="font-heading text-xl font-bold text-base-dark mb-1" data-id="element-246">
                        {unit.kod}
                      </h4>
                      <p className="text-base-gray text-sm mb-3" data-id="element-247">
                        {unit.kategorie} · Vchod {unit.vchod} · {unit.patro}
                      </p>
                      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-base-gray" data-id="element-248">
                        <span data-id="element-249">
                          Plocha:{' '}
                          <strong className="text-base-dark" data-id="element-250">
                            {formatArea(unit.uzitnaPlochM2)}
                          </strong>
                        </span>
                        {unit.balkonM2 && <span data-id="element-251">
                            Balkon:{' '}
                            <strong className="text-base-dark" data-id="element-252">
                              {formatArea(unit.balkonM2)}
                            </strong>
                          </span>}
                        {unit.terasaM2 && <span data-id="element-253">
                            Terasa:{' '}
                            <strong className="text-base-dark" data-id="element-254">
                              {formatArea(unit.terasaM2)}
                            </strong>
                          </span>}
                      </div>
                    </div>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>}

        {/* CTA buttons */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-255">
          <a href="#nabidka-bytu" className="inline-block bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-256">
            Zobrazit všechny byty
          </a>
          <a href="#kontakt" className="inline-block bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide" data-id="element-257">
            Kontaktujte nás pro ceník
          </a>
        </motion.div>
      </div>
    </section>;
}